import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class AgendaPriority extends EntityDto implements IEntityDto {
    Agenda_Priority_Id: string;
    AgendaPriorityName: string;
    Description: string;
    OrderNo: number| undefined;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Agenda_Priority_Id = "00000000-0000-0000-0000-000000000000";
        this.AgendaPriorityName = "";
        this.Description = "";
        this.TotalCount = 0;
        this.OrderNo = undefined;
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'AgendaPriorityName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Priority Name is required' },
            { FieldName: 'OrderNo', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Order No. is required' },

        ];
    }
}
